import { CoreIcon } from '../core-icon';
import chargeSVG from '../../assets/icons/charge.svg';
import type { IconProps } from '../core-icon';

export const ChargeIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chargeSVG} {...props} />;
};
